export const OPEN_LAYOUT_WIDGET_BUS_NAME = 'open-layout-widget'
export const CLOSE_LAYOUT_WIDGETS_BUS_NAME = 'close-layout-widgets'
